module.exports = __webpack_public_path__ + "audio-980053a8332f.m4a";